module.exports = __webpack_public_path__ + "static/media/em-111.bf5bf7d4.png";